export enum HasNotary {
  YES = 'YES',
  NO = 'NO',
}
